/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerieSerieidLangsAvailableLanguages200,
  GetApiV1SerieSerieidLangsAvailableLanguages401,
  GetApiV1SerieSerieidLangsAvailableLanguages404,
  GetApiV1SerieSerieidLangsAvailableLanguages500,
  GetApiV1SerieSerieidLangsAvailableLanguagesPathParams,
  GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1SerieSerieidLangsAvailableLanguagesPathParamsSchema =
  z.object({
    serieId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerieSerieidLangsAvailableLanguages200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerieSerieidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerieSerieidLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerieSerieidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguages500>;

export const getApiV1SerieSerieidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1SerieSerieidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse>;
